const RELOAD_KEY = '__mazpin_chunk_reload_at'
const CACHE_BUST_KEY = '__mazpin_chunk_reload_cachebust'
// Window in which a second reload is suppressed to prevent reload loops
// when the new deploy is also broken.
const RELOAD_COOLDOWN_MS = 10_000

const CHUNK_ERROR_PATTERNS = [
  'Failed to fetch dynamically imported module',
  'Importing a module script failed',
  'error loading dynamically imported module',
]

export function isChunkLoadError(error: unknown): boolean {
  if (!error) return false

  if (typeof error === 'object') {
    const err = error as { name?: unknown; message?: unknown }
    if (err.name === 'ChunkLoadError') return true
    const message = typeof err.message === 'string' ? err.message : ''
    if (message) {
      if (CHUNK_ERROR_PATTERNS.some((p) => message.includes(p))) return true
      if (message.includes('Loading chunk') && message.includes('failed')) return true
    }
  }

  if (typeof error === 'string') {
    if (CHUNK_ERROR_PATTERNS.some((p) => error.includes(p))) return true
    if (error.includes('Loading chunk') && error.includes('failed')) return true
  }

  return false
}

function readReloadTimestamp(): number {
  try {
    const raw = sessionStorage.getItem(RELOAD_KEY)
    if (!raw) return 0
    const n = Number(raw)
    return Number.isFinite(n) ? n : 0
  } catch {
    return 0
  }
}

function hasCacheBusted(): boolean {
  try {
    return sessionStorage.getItem(CACHE_BUST_KEY) === '1'
  } catch {
    return false
  }
}

export function reloadOnceForStaleChunk(reason: string): void {
  if (typeof window === 'undefined') return

  const now = Date.now()
  const lastReload = readReloadTimestamp()
  const withinCooldown = lastReload > 0 && now - lastReload < RELOAD_COOLDOWN_MS

  // If we're inside the cooldown window, the previous plain reload didn't help.
  // Try one cache-busting reload before giving up.
  if (withinCooldown) {
    if (hasCacheBusted()) {
      console.error(
        `[chunkReload] skip reload (cooldown ${String(now - lastReload)}ms, already cache-busted): ${reason}`,
      )
      return
    }
    try {
      sessionStorage.setItem(CACHE_BUST_KEY, '1')
      sessionStorage.setItem(RELOAD_KEY, String(now))
    } catch {
      // ignore
    }
    console.warn(`[chunkReload] cache-busting reload: ${reason}`)
    const url = new URL(window.location.href)
    url.searchParams.set('v', String(now))
    window.location.replace(url.toString())
    return
  }

  try {
    sessionStorage.setItem(RELOAD_KEY, String(now))
  } catch {
    // sessionStorage may be unavailable (private mode, etc). Proceed anyway.
  }

  console.warn(`[chunkReload] reloading: ${reason}`)
  window.location.reload()
}
